import { Component, Input, Output, EventEmitter, OnInit, AfterViewInit, HostListener, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-internet-search-enrichments',
  templateUrl: './internet-search-enrichments.component.html',
  styleUrls: ['./internet-search-enrichments.component.css']
})
export class InternetSearchEnrichmentsComponent implements OnInit {

  @Input() internetSearch: any;
  @Output() globalServicesCallBack: EventEmitter<any> = new EventEmitter<any>();


  public inputLink = "";
  public dropZone;
  public invalidUrl: boolean = false;
  public titleInput = "";
  uHeaderVal = 'https';
  urlHeader = ['http', 'https'];

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit() {

  }

  hideinternetDialog(evt) {
    if (evt) {
      evt.stopPropagation();
    }
    else {
      this.internetSearch.showPopup = false;
    }
  }

  close() {
    this.hideinternetDialog(undefined);
  }

  clearInput() {
    this.invalidUrl = false;
    this.inputLink = "";
  }

  inputClick() {
    this.invalidUrl = false;
  }

  ngAfterViewInit() {

    var _this = this;
    var dropEle = document.getElementsByClassName('DragnDropSection')

    dropEle[0].addEventListener("dragover", function (event) {
      event.preventDefault();
    }, false);

    dropEle[0].addEventListener("drop", function (event) {
      event.preventDefault();
      _this.inputLink = event['dataTransfer'].getData('URL');

      if (_this.inputLink.indexOf("https://") != -1) {
        _this.inputLink = _this.inputLink.replace('https://', '')
        _this.uHeaderVal = 'https';
      }
      else if (_this.inputLink.indexOf("http://") != -1) {
        _this.inputLink = _this.inputLink.replace('http://', '')
        _this.uHeaderVal = 'http';
      }

      _this.invalidUrl = false;
      _this.cdr.detectChanges();
    }, false);

    let internetSearchCon = document.getElementsByClassName('internetSearchCon')

    internetSearchCon[0].addEventListener("dragover", function (event) {
      event.preventDefault();
    }, false);

    internetSearchCon[0].addEventListener("drop", function (event) {
      event.preventDefault();
    }, false);

  }

  // validate(url) {
  //   var pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
  //   if (pattern.test(url)) {
  //     return true;
  //   }
  //   return false;
  // }

  addAsTab() {
    if (this.inputLink.length > 0) {

      if (this.uHeaderVal == 'https') {
        this.inputLink = "https://" + this.inputLink;
      }
      else if (this.uHeaderVal == 'http') {
        this.inputLink = "http://" + this.inputLink;
      }

      var obj = {
        id: 3,
        icon: "icon-Internet-search",
        text: "Internet search",
        color: "#FF5722",
        type: "internet",
        url: this.inputLink,
        title: this.titleInput
      };
      this.globalServicesCallBack.emit(obj);
      this.hideinternetDialog(undefined);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/enrichmentTabs/internet-search-enrichments/internet-search-enrichments.component.ts